import type { ReactNode } from "react";

// One column grammar for engine/domain identity, primary measure and visualization.
export const RANKING_ROW =
  "flex min-w-0 w-full items-center gap-3 border-b border-border px-3 py-3 last:border-b-0";
export const RANKING_METRIC = "w-20 shrink-0 text-right";
export const RANKING_VIZ = "h-8 w-20 shrink-0 @sm:w-24";
export const RANKING_META =
  "mt-1 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-xs leading-4 text-muted";

export function RankingList({
  identity,
  metric,
  visualization,
  children,
}: {
  identity: string;
  metric: string;
  visualization: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-0 flex-1 overflow-auto">
      <div className="sticky top-0 z-10 flex items-center gap-3 border-b border-border bg-surface-elevated px-3 py-2 text-xs font-medium text-muted">
        <span className="min-w-0 flex-1">{identity}</span>
        <span className={RANKING_METRIC}>{metric}</span>
        <span className="w-20 shrink-0 text-right @sm:w-24">{visualization}</span>
      </div>
      {children}
    </div>
  );
}
